function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudcraft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.622 1158.929 49.097-28.346 49.098 28.346-98.195 56.693z",
    style: {
      display: "inline",
      fill: "#4286c5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.476 960.504v340.157l-49.097-28.346V932.157z",
    style: {
      display: "inline",
      fill: "#30689c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-47.476 960.504 147.293-85.04v56.693L1.622 988.85v226.772l98.195-56.693v56.693l-147.293 85.04z",
    style: {
      display: "inline",
      fill: "#22496e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.72 1130.583 49.097 28.346 98.195-56.693-49.098-28.346z",
    style: {
      display: "inline",
      fill: "#f5b720",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.914 903.81 49.098-28.345v226.771l-49.098-28.346z",
    style: {
      display: "inline",
      fill: "#e4a40a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.817 875.465v56.692l98.195-56.692v226.771l-98.195 56.693v56.693l147.292-85.04V790.426z",
    style: {
      display: "inline",
      fill: "#c08a08",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-96.573 932.157 49.097 28.347 147.293-85.04-49.098-28.346z",
    style: {
      display: "inline",
      fill: "#4286c5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.72 847.118 49.097 28.346 147.292-85.039-49.097-28.346z",
    style: {
      display: "inline",
      fill: "#f5b720",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(36.025 -141.497) scale(.18567)"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudcraft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloudcraft.10f1c71d6bef45e483d495f5836262a7.svg";